import React from "react";
import classNames from "classnames";

type PropsType = {
  classNameProps?: string;
  height?: number;
  width?: number;
  target?: boolean;
  targetEarned?: boolean;
  star?: boolean;
  starEarned?: boolean;
  lightning?: boolean;
  lightningEarned?: boolean;
  active?: boolean;
};

function IndicatorSVG({
  classNameProps,
  height = 30,
  width = 30,
  target,
  targetEarned,
  star,
  starEarned,
  lightning,
  lightningEarned,
  active,
}: PropsType) {
  let starClass = star
    ? "stroke-green dark:stroke-green-dark-default"
    : "stroke-grey-light dark:stroke-grey-dark-light";
  let targetClass = target
    ? "stroke-orange dark:stroke-orange-dark-default"
    : "stroke-grey-light dark:stroke-grey-dark-light";
  let lightningClass = lightning
    ? "stroke-purple dark:stroke-purple-dark-default"
    : "stroke-grey-light dark:stroke-grey-dark-light";

  if (active) {
    if (starEarned) {
      starClass = "stroke-green-light dark:stroke-green-dark-light";
    }

    if (targetEarned) {
      targetClass = "stroke-orange-light dark:stroke-orange-dark-light";
    }

    if (lightningEarned) {
      lightningClass = "stroke-purple-light dark:stroke-purple-dark-light";
    }
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <circle cx='15' cy='15' r='15' className='fill-bg-strong' />
      <circle
        cx='15'
        cy='15'
        r='13.5'
        className={classNames(starClass)}
        strokeWidth='3'
      />
      <circle
        cx='15'
        cy='15'
        r='8.5'
        className={classNames(targetClass)}
        strokeWidth='3'
      />
      <circle
        cx='15'
        cy='15'
        r='3.5'
        className={classNames(lightningClass)}
        strokeWidth='3'
      />
    </svg>
  );
}

export default IndicatorSVG;
